export default __webpack_public_path__ + "static/media/medium.9c98d474.svg";